export const GET_REVIEWS = "GET_REVIEWS";
export const GET_RATES = "GET_RATES";
export const ERROR_REVIEW = "ERROR_REVIEW";